import { useState } from 'react';
import { Play } from 'lucide-react';

const ETAPES = [
  { img: 'accueil', titre: 'Le matin, tout est prêt', texte: "Tâches du jour, météo, alertes : Valentine a déjà trié l'essentiel." },
  { img: 'parcellaire', titre: 'Vos parcelles sur la carte', texte: 'Surfaces, cultures, îlots PAC : tout votre parcellaire au même endroit.' },
  { img: 'registre', titre: 'Le registre se remplit tout seul', texte: 'Après chaque dictée, le registre et la traçabilité sont à jour.' },
  { img: 'planning', titre: "L'équipe et le matériel organisés", texte: 'Planning des personnes et des machines, heures comptées automatiquement.' },
  { img: 'materiel', titre: 'Votre parc matériel suivi', texte: 'Entretiens, coûts, disponibilités : fini les oublis.' },
  { img: 'facturation', titre: 'Facturer sans ressaisir', texte: 'Devis, factures et facturation électronique, prêts à envoyer.' },
];

export const DemoCaptures = ({ metier }) => {
  const [actif, setActif] = useState(0);
  const e = ETAPES[actif];
  return (
    <section data-testid="tunnel-captures" className="px-6 md:px-12 py-16">
      <p className="text-xs uppercase tracking-[0.25em] text-[#8a6d12] mb-3">La visite guidée</p>
      <h2 className="text-3xl md:text-4xl text-[#12321f] mb-8">Une journée type avec Bureau Agricole : {metier}</h2>
      <div className="grid lg:grid-cols-[1fr_320px] gap-8 items-start">
        <div className="relative rounded-2xl overflow-hidden shadow-2xl ring-1 ring-black/10 bg-white">
          <div className="flex items-center gap-2 px-4 py-2 bg-[#12321f] text-white text-xs">
            <span className="h-2.5 w-2.5 rounded-full bg-red-400" /><span className="h-2.5 w-2.5 rounded-full bg-yellow-300" />
            <span className="h-2.5 w-2.5 rounded-full bg-green-400" /><span className="ml-3 opacity-70">Étape {actif + 1} / {ETAPES.length} : {e.titre}</span>
          </div>
          <img key={e.img} src={`/tunnel/${e.img}.jpg`} alt={e.titre} data-testid="tunnel-capture-image" className="w-full reveal" />
          <div className="md:absolute md:bottom-4 md:left-4 flex items-center gap-3 md:rounded-full bg-[#12321f] md:bg-black/75 pl-1 pr-4 py-1 text-white text-sm md:backdrop-blur">
            <span className="grid h-10 w-10 place-items-center rounded-full bg-[#c9a227] text-[#12321f] font-bold">V</span>
            {e.texte}
          </div>
        </div>
        <ol className="space-y-2">
          {ETAPES.map((x, i) => (
            <li key={x.img}>
              <button type="button" onClick={() => setActif(i)} data-testid={`tunnel-etape-${x.img}`}
                className={`w-full text-left rounded-xl px-4 py-3 transition-colors ${i === actif ? 'bg-[#12321f] text-white' : 'bg-white hover:bg-[#ece5d3]'}`}>
                <span className="flex items-center gap-2 font-bold text-sm"><Play className="h-3.5 w-3.5" />{i + 1}. {x.titre}</span>
              </button>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
